import { DateRangeRounded } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { getFormSubmissionPeriod } from "src/utilities";
import { ItemProperty } from "../itemProperties";

interface Props {
  dateRangeStartUtc: string;
  dateRangeEndUtc: string;
}

const FormSubmissionPeriodProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<DateRangeRounded />} label="Period">
      <Typography>{getFormSubmissionPeriod(props.dateRangeStartUtc, props.dateRangeEndUtc)}</Typography>
    </ItemProperty>
  );
};

export { FormSubmissionPeriodProperty };
